import { createContext } from "react";

import { ConditionsSidePanelHelper } from "./ConditionsSidePanelHelper.ts";

export const ClaimAppointmentContext = createContext<ConditionsSidePanelHelper>(
  {} as ConditionsSidePanelHelper
);
